/** @type {import('../help-index.js').HelpSidebarItem} */
export const AGR_CAM_AGUAS_ITEM = {
  id: 'agro_aguas',
  screenId: 'agr-cam-aguas',
  label: 'Aguas',
  description: 'Consulta, análisis de agua de riego o pozo y parámetros.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Similar a Suelos, pero para calidad de agua (pozo, canal, red, etc.): consultás el último estado, cargás análisis y mantenés los parámetros medibles.',
      },
      {
        title: 'Pestañas',
        bullets: [
          'Consulta — valores recientes del agua del campo o zona.',
          'Análisis — historial y alta de análisis.',
          'Parámetros — catálogo de lo que se mide en agua.',
        ],
      },
      {
        title: 'Selector de lugar',
        fields: [
          {
            label: 'Campo',
            description: 'Campo asociado al agua analizada.',
          },
          {
            label: 'Zona',
            description: 'Opcional, si el agua se asocia a una zona puntual.',
          },
        ],
      },
      {
        title: 'Pestaña Análisis — lista',
        bullets: [
          'Columnas típicas: Fecha de análisis, Laboratorio, Número de muestra, Origen.',
          'El botón + abre un análisis nuevo.',
          'Desde el detalle podés editar o eliminar según permisos.',
        ],
      },
      {
        title: 'Pestaña Análisis — formulario',
        fields: [
          {
            label: 'Campo / Zona',
            description: 'Lugar al que corresponde la muestra.',
          },
          {
            label: 'Laboratorio',
            description: 'Laboratorio que emitió el informe.',
          },
          {
            label: 'Número de muestra',
            description: 'Código de la muestra.',
          },
          {
            label: 'Fecha de extracción',
            description: 'Cuándo se tomó el agua.',
          },
          {
            label: 'Fecha del análisis',
            description: 'Fecha del informe.',
          },
          {
            label: 'Responsable',
            description: 'Quién tomó o cargó la muestra.',
          },
          {
            label: 'Origen de la muestra',
            description: 'De dónde salió el agua (pozo, canal, tanque, etc.).',
          },
          {
            label: 'Ubicación GPS (opcional)',
            description: 'Punto en el mapa donde se tomó la muestra.',
          },
          {
            label: 'Resultados por parámetro',
            description: 'Valores del informe según los parámetros de agua activos.',
          },
          {
            label: 'Notas',
            description: 'Observaciones libres.',
          },
        ],
      },
      {
        title: 'Pestaña Parámetros',
        paragraphs: [
          'Igual que en Suelos: Nombre, Abreviatura, Método, Unidad y Tipo de valor. Usá el botón + para agregar parámetros propios; los de sistema ya vienen cargados.',
        ],
      },
    ],
  },
}
